import { initialOptionalFields } from './actions';

export default {
  setTheme: (state, { newState, vuetify }) => {
    delete newState.__v;
    delete newState._id;
    state.dark = { ...newState.dark };
    state.light = { ...newState.light };
    state.font = newState.font;
    state.darkMode = newState.darkMode;
    state.logo = newState.logo !== 'empty' ? newState.logo : null;
    state.uri = newState.uri;
    state.organizationId = newState.organizationId;
    state.updatedAt = newState.updatedAt;
    state.updatedBy = newState.updatedBy;
    if (!newState.optionalFields) {
      newState.optionalFields = initialOptionalFields;
    }
    state.optionalFields = newState.optionalFields;
    state.overrideDefaultTheme = newState.overrideDefaultTheme;
    helpers.setVuetifyThemeColors(newState, vuetify);
  }
};

const helpers = {
  setVuetifyThemeColors({ dark, light, darkMode }, vuetify) {
    Object.keys(dark).forEach(key => {
      vuetify.theme.themes.dark[`custom-${key}`] = darkMode ? dark[key] : light[key];
    });
  }
};
